module.exports = __webpack_public_path__ + "img/sofa.138130d9.png";